import { appstr } from "@coreapp/utils/appstr";
import { AuditEventType, AuditOutcome, AuditSource } from "./constants";

export const getEventTypeLabel = eventType => {
  switch (eventType) {
    case AuditEventType.USER_CREATE:
      return appstr("auditLog.event.userCreate");
    case AuditEventType.USER_DELETE:
      return appstr("auditLog.event.userDelete");
    case AuditEventType.USER_DELETE_REQUEST:
      return appstr("auditLog.event.userDeleteRequest");
    case AuditEventType.USER_ROLE_CHANGE:
      return appstr("auditLog.event.userRoleChange");
    case AuditEventType.USER_PRIV_CHANGE:
      return appstr("auditLog.event.userPrivChange");
    case AuditEventType.USER_RLS_ASSIGN:
      return appstr("auditLog.event.userRlsAssign");
    case AuditEventType.SECURITY_GROUP_UPDATE:
      return appstr("auditLog.event.securityGroupUpdate");
    case AuditEventType.SECURITY_RLS_PROFILE_UPDATE:
      return appstr("auditLog.event.securityRlsProfileUpdate");
    case AuditEventType.SECURITY_BLS_PROFILE_UPDATE:
      return appstr("auditLog.event.securityBlsProfileUpdate");
    case AuditEventType.SECURITY_IMPERSONATION_TOGGLE:
      return appstr("auditLog.event.securityImpersonationToggle");
    case AuditEventType.SECURITY_DIRECT_SIGNIN_TOGGLE:
      return appstr("auditLog.event.securityDirectSigninToggle");
    case AuditEventType.SECURITY_AUTO_ASSIGNMENT_CHANGE:
      return appstr("auditLog.event.securityAutoAssignmentChange");
    case AuditEventType.SECURITY_SSO_CONFIG_CHANGE:
      return appstr("auditLog.event.securitySsoConfigChange");
    case AuditEventType.SECURITY_AUTHORIZATION_DENIED:
      return appstr("auditLog.event.securityAuthorizationDenied");
    case AuditEventType.SECURITY_UI_PROFILE_UPDATE:
      return appstr("auditLog.event.securityUiProfileUpdate");
    case AuditEventType.AUTH_LOGIN_IMPERSONATION:
      return appstr("auditLog.event.authLoginImpersonation");
    case AuditEventType.AUDIT_REPORT_VIEWED:
      return appstr("auditLog.event.auditReportViewed");
    case AuditEventType.AUDIT_REPORT_EXPORTED:
      return appstr("auditLog.event.auditReportExported");
    case AuditEventType.AUDIT_REPORT_EXPORTED_XLSX:
      return appstr("auditLog.event.auditReportExportedXlsx");
    case AuditEventType.AUDIT_SNAPSHOT_GENERATED:
      return appstr("auditLog.event.auditSnapshotGenerated");
    default:
      return eventType || "";
  }
};

export const getOutcomeLabel = outcome => {
  switch (outcome) {
    case AuditOutcome.SUCCESS:
      return appstr("auditLog.outcome.success");
    case AuditOutcome.DENIED:
      return appstr("auditLog.outcome.denied");
    case AuditOutcome.FAILED:
      return appstr("auditLog.outcome.failed");
    default:
      return outcome || "";
  }
};

export const getSourceLabel = source => {
  switch (source) {
    case AuditSource.MANAGE_USERS_UI:
      return appstr("auditLog.source.manageUsersUi");
    case AuditSource.AUTHORIZATION_UI:
      return appstr("auditLog.source.authorizationUi");
    case AuditSource.RLS_UI:
      return appstr("auditLog.source.rlsUi");
    case AuditSource.BLS_UI:
      return appstr("auditLog.source.blsUi");
    case AuditSource.ACCESS_GROUPS_UI:
      return appstr("auditLog.source.accessGroupsUi");
    case AuditSource.UI_PROFILES_UI:
      return appstr("auditLog.source.uiProfilesUi");
    case AuditSource.SSO_CONFIG_UI:
      return appstr("auditLog.source.ssoConfigUi");
    case AuditSource.AUDIT_LOG_UI:
      return appstr("auditLog.source.auditLogUi");
    case AuditSource.BULK_IMPORT:
      return appstr("auditLog.source.bulkImport");
    case AuditSource.API:
      return appstr("auditLog.source.api");
    case AuditSource.SYSTEM:
      return appstr("auditLog.source.system");
    case AuditSource.UNKNOWN:
      return appstr("auditLog.source.unknown");
    default:
      return source || "";
  }
};
